/**
 * 工單轉倉 detail → 雙欄 draft（camel）。
 * 優先 inputQty／inputUnitId；fallback qty＋unit.id。
 * availableQty 初值暫用 qty；candidates 後補 base。
 */

import {
  extractUnitOptions,
  resolveUnitId,
} from '#/modules/imsMgmt/helper/materialUnit';

function formatFromWarehouseLabel(fromWarehouse) {
  if (!fromWarehouse) {
    return '';
  }
  const warehouseLabel = [fromWarehouse.code, fromWarehouse.name].filter(Boolean).join(' - ')
    || fromWarehouse.name
    || '';
  const location = fromWarehouse.location;
  const locationLabel = location
    ? ([location.code, location.name].filter(Boolean).join(' ') || '')
    : '';
  return [warehouseLabel, locationLabel].filter(Boolean).join(' / ');
}

/**
 * @param {object} detail
 * @param {{ demandMtrIds?: Set<string>|string[] }} [options]
 */
export function mapWorkOrderTransferDetailToDraft(detail, { demandMtrIds } = {}) {
  const demandIds = demandMtrIds instanceof Set
    ? demandMtrIds
    : new Set(demandMtrIds ?? []);
  const hasDemand = demandIds.size > 0;

  const draftLines = (detail?.lines ?? []).map((line) => {
    const mtrId = line?.mtr?.id ?? '';
    const inputQtyRaw = line?.inputQty;
    const qty = inputQtyRaw != null && inputQtyRaw !== ''
      ? (Number(inputQtyRaw) || 0)
      : (Number(line?.qty) || 0);
    const unitId = String(line?.inputUnitId ?? '').trim()
      || resolveUnitId(line?.unit)
      || resolveUnitId(line)
      || '';
    const unitOptions = extractUnitOptions(line?.mtr ?? line);

    return {
      mtrId,
      mtrNo: line?.mtr?.mtrNo ?? '',
      mtrName: line?.mtr?.name ?? '',
      invStockId: line?.sourceInvStock?.id ?? line?.invStockId ?? '',
      stockNo: line?.sourceInvStock?.stockNo ?? '',
      qty,
      availableQty: qty,
      unitId,
      unitOptions,
      fromWarehouseLabel: formatFromWarehouseLabel(line?.fromWarehouse),
      stockNoPolicy: line?.stockNoPolicy || 'TRANSFERRED_KEEP_OLD',
      toLocationId: line?.toLocation?.id ?? line?.toLocationId ?? null,
      remark: line?.remark ?? null,
      isOtherMaterial: hasDemand ? !demandIds.has(mtrId) : false,
    };
  }).filter((line) => line.invStockId);

  return {
    transferDate: detail?.transferDate ?? '',
    toWarehouseId: detail?.toWarehouse?.id ?? detail?.toWarehouseId ?? '',
    issueReason: detail?.issueReason ?? null,
    remark: detail?.remark ?? null,
    updatedAt: detail?.updatedAt ?? detail?.record?.updatedAt ?? null,
    draftLines,
  };
}

/**
 * candidates 回來後補 availableQty，並依左欄需求重算 isOtherMaterial。
 */
export function applyTransferCandidatesToDraftLines(draftLines = [], materials = []) {
  const demandIds = new Set(
    (materials ?? []).map((material) => material?.mtrId).filter(Boolean),
  );
  const stockById = new Map();
  (materials ?? []).forEach((material) => {
    (material?.transferableInventoryStocks ?? []).forEach((stock) => {
      if (stock?.id) {
        stockById.set(stock.id, stock);
      }
    });
  });

  return (draftLines ?? []).map((line) => {
    const stock = stockById.get(line?.invStockId);
    const mtrId = line?.mtrId;
    return {
      ...line,
      availableQty: stock?.availableQty ?? line?.availableQty,
      isOtherMaterial: mtrId ? !demandIds.has(mtrId) : true,
    };
  });
}
